// extracted by mini-css-extract-plugin
export default {"cred_label":"add-azure-firewall_cred_label__WDciv"};